export default {
    workLoadTypes:          { method: 'get',    url: 'work_load_types' },
    workLoadTypeCreate:     { method: 'post',   url: 'work_load_types' },
    workLoadTypeUpdate:     { method: 'put',    url: 'work_load_types/{id}' },
    workLoadTypeDelete:     { method: 'delete', url: 'work_load_types/{id}' },
    workLoadTypePositions:        { method: 'get',    url: 'work_load_types/{id}/positions' },
    workLoadTypePositionCreate:   { method: 'post',   url: 'work_load_types/{id}/positions' },
    workLoadTypePositionUpdate:   { method: 'put',    url: 'work_load_types/{id}/positions/{positionId}' },
    workLoadTypePositionDelete:   { method: 'delete', url: 'work_load_types/{id}/positions/{positionId}' },
}